import { get, post, del, put, patch } from "../common/apiClient";

const PATH = "/user-vocab";
const MASTER = "/master-vocab";

// ── Master vocab browse (admin-managed content) ───────────────────────────────
export const getMasterTopics = () => get(`${MASTER}/topics`);

export const getMasterVocabList = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return get(`${MASTER}/vocab${query ? `?${query}` : ""}`);
};

// ── Master vocab search (for highlight/lookup) ────────────────────────────────
export const searchMasterVocab = (q, limit = 10) =>
  get(`${PATH}/search?q=${encodeURIComponent(q)}&limit=${limit}`);

// ── Segment text (called on save icon click) ──────────────────────────────────
export const segmentText = (text) => post(`${PATH}/segment`, { text });

// ── User vocab ────────────────────────────────────────────────────────────────
export const getUserVocabs = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return get(`${PATH}${query ? `?${query}` : ""}`);
};

export const saveVocab = (masterVocabId, folderId = null) =>
  post(`${PATH}/save`, { masterVocabId, ...(folderId && { folderId }) });

export const deleteUserVocab = (id) => del(`${PATH}/${id}`);

// ── Folders ───────────────────────────────────────────────────────────────────
export const getFolders = () => get(`${PATH}/folders`);

export const createFolder = (name) => post(`${PATH}/folders`, { name });

export const updateFolder = (id, name) => put(`${PATH}/folders/${id}`, { name });

export const deleteFolder = (id) => del(`${PATH}/folders/${id}`);

export const addToFolder = (folderId, userVocabId) =>
  post(`${PATH}/folders/${folderId}/items`, { userVocabId });

export const removeFromFolder = (folderId, itemId) =>
  del(`${PATH}/folders/${folderId}/items/${itemId}`);

// ── SRS review ────────────────────────────────────────────────────────────────
export const getReviewCards = () => get(`${PATH}/review`);

export const reviewUserVocab = (id, action) =>
  patch(`${PATH}/${id}/review`, { action });
